import actions from '../action/activity'
import CONSTANT from '../constant/activity'
import _ from 'underscore'

export default {
  actions,
  state: {
    isHomeActQualified: false,
    homeAct: {},
    act: {},
    isHomeFloatBanner: false,
    UUGroupList: [],
    UUGroupListPageIndex: 1,
    UUGroupDetail: {},
    UUGroupActGroupList: [],
    UUGroupActGroupDetail: {},
  },
  mutations: {
    [CONSTANT.ACTIVITY_GET_HOMESTATUS_SUCCESS] (state, {canJoin, act = {}}) {
      state.isHomeActQualified = !!canJoin
      state.homeAct = Object.assign({}, Object.assign({}, state.homeAct, act))
    },
    [CONSTANT.ACTIVITY_GET_HOMESTATUS_ERROR] (state) {
      state.isHomeActQualified = false
    },
    [CONSTANT.ACTIVITY_GET_HOME_FLOATBANNER_SUCCESS] (state, data) {
      state.act = data
      state.isHomeFloatBanner = !!data.isDefaultShow
    },
    [CONSTANT.ACTIVITY_GET_HOME_FLOATBANNER_ERROR] (state, data) {
      state.act = {}
      state.isHomeFloatBanner = false
    },
    changeIconFloatBanner(state, data) {
      state.isHomeFloatBanner = data.isHomeFloatBanner
    },
    [CONSTANT.ACTIVITY_GET_UUG_ACT_LIST_SUCCESS] (state, data) {
      state.UUGroupList = state.UUGroupList.concat(data.list)
      state.UUGroupListPageIndex = data.pageIndex
    },
    [CONSTANT.ACTIVITY_GET_UUG_ACT_LIST_ERROR] (state, data) {
    },
    [CONSTANT.ACTIVITY_GET_UUG_ACT_DETAIL_SUCCESS] (state, data) {
      state.UUGroupDetail = data
    },
    [CONSTANT.ACTIVITY_GET_UUG_ACT_DETAIL_ERROR] (state, data) {
      state.UUGroupDetail = {}
    },
    [CONSTANT.ACTIVITY_GET_UUG_ACT_GROUP_LIST_SUCCESS] (state, data) {
      state.UUGroupActGroupList = state.UUGroupActGroupList.concat(data.list)
    },
    [CONSTANT.ACTIVITY_GET_UUG_ACT_GROUP_LIST_ERROR] (state, data) {
    },
    [CONSTANT.ACTIVITY_GET_UUG_ACT_GROUP_DETAIL_SUCCESS] (state, data) {
      state.UUGroupActGroupDetail = data
    },
    [CONSTANT.ACTIVITY_GET_UUG_ACT_GROUP_DETAIL_ERROR] (state, data) {
      state.UUGroupActGroupDetail = {}
    },
  },
  getters: {
    [CONSTANT.ACTIVITY_CAN_SHOW_HOMEACT] (state, { nowShowTimes = 0 }) {
      return state.homeAct.showTimesLimit > nowShowTimes ? true : false
    }
  }
}
